import React from 'react';
import styled from 'styled-components';
import { colors, Heading, Checkbox } from '@telia/styleguide';
import { SalesPackage } from '../../types';

import SummaryWidget from '../../modules/summary/SummaryWidget';
import { MediaQueries } from '../../util/MediaQueries';

interface Props {
  salesPackage: SalesPackage | undefined;
  tvChecked: boolean;
  handleTvCheckChange: () => void;
}

const SalesPackageTV: React.FC<Props> = ({ salesPackage, handleTvCheckChange, tvChecked }) => {
  const hiddenProducts = [1887, 1818, 1935, 205, 1827, 639];
  let summarySalesPackage = undefined;
  if (salesPackage) {
    summarySalesPackage = {
      ...salesPackage,
      products: salesPackage
        ? salesPackage.products.filter(product => !hiddenProducts.includes(product.commercialProductId))
        : []
    };
  }
  return (
    <>
      <Container
        id="tv-container"
        onKeyDown={e => e.key === 'Enter' && handleTvCheckChange()}
        tvChecked={tvChecked}
        tabIndex={0}
      >
        <RadioIcon>
          <Checkbox
            hiddenLabel
            label=""
            id="tv-checkbox"
            checked={tvChecked}
            onChange={() => {
              handleTvCheckChange();
            }}
          />
        </RadioIcon>
        <>
          <NameContainer>
            <PackageName tag="h3" size="s" text={'TV & Strømming'} />
            <Points>
              <strong>50</strong> poeng
            </Points>
          </NameContainer>
          <Price style={{ flex: '1', textAlign: 'end' }}>
            <strong>499,-</strong> /md.
          </Price>
        </>
      </Container>
      {tvChecked && summarySalesPackage && (
        <SummaryWidget selectedBundle={summarySalesPackage} selectedAdditionalProducts={[]} hideOffer={false} />
      )}
    </>
  );
};

export default SalesPackageTV;

interface ContainerProp {
  tvChecked: boolean;
}

const Container = styled.div<ContainerProp>`
  border-radius: 4px;
  display: flex;
  margin: 1rem 0;
  padding: 1rem;
  max-width: 560px;
  height: 94px;
  width: 100%;
  position: relative;
  overflow: hidden;
  background-color: ${props => (props.tvChecked ? colors.lightGrey : 'white')};
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
  align-items: center;
  cursor: pointer;
  transition: border 150ms ease-out;
  ${MediaQueries.notDesktop} {
    height: 100%;
  }
`;
const NameContainer = styled.div`
  display: flex;
  flex-direction: row;

  ${MediaQueries.notDesktop} {
    margin: 0 0 0 0.5rem;
    max-height: 90px;
    flex-direction: column;
  }
`;

const RadioIcon = styled.div`
  margin: 0 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  ${MediaQueries.onlyMobile} {
    margin: 0 0.5rem 0 1rem;
  }
`;

const PackageName = styled(Heading)`
  text-transform: uppercase;
  font-family: Pebble, Helvetica, Roboto, Arial, sans-serif;

  ${MediaQueries.notDesktop} {
    font-size: 1.2rem;
    margin: 0;
    width: 70%;
  }
`;

const Points = styled.p`
  /* margin: 0 1rem 0 0; */
  font-size: 1.375rem;
  line-height: 1.75rem;
  margin-left: 1rem;
  strong {
    font-size: 1.375rem; // 22px
    font-family: Pebble, Helvetica, Roboto, Arial, sans-serif;
    ${MediaQueries.onlyMobile} {
      font-size: 1rem;
    }
  }
  ${MediaQueries.medium} {
    margin-right: 0.5rem;
  }
`;
const Price = styled.p`
  margin: 0 1rem 0 0;
  font-size: 1rem;
  strong {
    font-size: 1.375rem; // 22px
    font-family: Pebble, Helvetica, Roboto, Arial, sans-serif;
    ${MediaQueries.onlyMobile} {
      font-size: 1rem;
    }
  }
  ${MediaQueries.medium} {
    margin-right: 0.5rem;
  }
`;
